import LayoutContent from '../../components/layouts/content2';
import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';

function Index({ setShowHappy }) {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;

  const { change } = useRefresh();

  const [menus, setMenus] = useState([]);

  const [showSpecials, setShowSpecials] = useState(false);
  const [showListProduct, setShowListProduct] = useState(false);
  const [dishs, setdishs] = useState(false);
  const [dataCocktail, setdataCocktail] = useState(false);

  useEffect(() => {
    getData('menu').then((items) => {
      const data = items.value.data;

      setMenus(data);
    });
  }, [change]);

  useEffect(() => {
    menus.map((item) => {
      if (item.id === 389) {
        setdataCocktail(item);
      }
    });
  }, [menus]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
      }}
    >
      <LayoutContent
        showBack={true}
        setShowSpecials={setShowHappy}
        setShowListProduct={setShowHappy}
      >
        <div style={{ padding: '0 20px' }}>
          <h1
            style={{
              color: 'white',
              textTransform: 'uppercase',
              fontSize: 40,
              fontWeight: '900',
              marginTop: 250,
            }}
          >
            margaritas & mojitos
          </h1>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap',
              paddingInline: 30,
              flexDirection: 'column',
            }}
          >
            <div
              onClick={() => {
                setdishs(dataCocktail);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 40,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    position: 'absolute',
                  }}
                >
                  margaritas
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(dataCocktail);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  mojitos
                </p>
              </div>
            </div>
          </div>
        </div>

        {showListProduct && (
          <ListProducts dishs={dishs} setShowListProduct={setShowListProduct} />
        )}

        {showSpecials && (
          <SpecialsScreen
            setShowListProduct={setShowSpecials}
            setShowHappy={setShowHappy}
          />
        )}
      </LayoutContent>
    </div>
  );
}
export default Index;
